import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "http://127.0.0.1:8000";
export const API_BASE = `${BACKEND_URL}/api`;

// Public axios instance
export const apiPublic = axios.create({
  baseURL: API_BASE,
  headers: {
    "Content-Type": "application/json",
  },
});

// Boss / Admin axios instance
export const apiBoss = axios.create({
  baseURL: API_BASE,
  headers: {
    "Content-Type": "application/json",
  },
});

apiBoss.interceptors.request.use((config) => {
  const token = localStorage.getItem("tablezy_boss_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default apiPublic;
